import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, [
    'status',
    'backoutOnly',
    'usageOnly',
    'index',
    'unbilledOnly',
    'rerateReasonCode',
  ]);
  const saveReratingBatch = `saveReratingBatch(input: ${dataModify})`;
  return gql`
  mutation {
    ${saveReratingBatch} {
      id
    }
  }
`;
};
